import React, { FC } from 'react';
import { calendarSharedStyles } from '../../calendarStyles';
import { ICalendlyScoutProps } from '../types';

interface CalendlyAccountDetailsProps {
  calendlyAccount: ICalendlyScoutProps;
  linkId?: string;
}

export const CalendlyAccountDetails: FC<CalendlyAccountDetailsProps> = ({
  linkId,
  calendlyAccount
}) => {
  const sharedCalendarClasses = calendarSharedStyles();

  const initials = calendlyAccount.user_name.split(' ').map((name) => name[0]);

  return (
    <div className={sharedCalendarClasses.recContainer}>
      <div className={sharedCalendarClasses.recImage}>{initials}</div>
      <div className={sharedCalendarClasses.recDetails}>
        <h4>{calendlyAccount.user_name}</h4>
        <a target="_blank" rel="noreferrer" href={calendlyAccount.scheduling_url} id={linkId}>
          {calendlyAccount.scheduling_url}
        </a>
      </div>
    </div>
  );
};
